<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/request-helper-status/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          New status
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <data-table
      :list_name="'request-helper-status'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/request-helper-status`"
    />
  </v-container>
</template>

<script>
export default {
  name: "RequestHelperStatusList",
  components: {
    DataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Status name', value: 'status_name' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['status_name'],
    search_param: '',
    attribute_list: ['id', 'status_name'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
